import React from 'react';
import { motion } from 'framer-motion';
export function TherapistPresentation() {
  return <section className="bg-transparent relative overflow-hidden" data-id="element-344">
      <div className="w-full" data-id="element-345">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} className="w-full" data-id="element-346">
          <img src="https://cdn.magicpatterns.com/uploads/gaG6TmHU7fS36gXwakgWLq/hf_20260519_152853_ca2a79b4-e63f-414b-8afe-77ae1932ec07.webp" alt="Sofía Alondra - Creadora de la Guía de Tarot Terapéutico" className="w-full h-auto block" data-id="element-347" />
        </motion.div>
      </div>
    </section>;
}